import config from "config/config";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { getConsentPDFContent } from "service/userservice/getConsentPDFContent";

const PanelFour = ({
  setCurrentStep,
  isConsentChecked,
  setIsConsentChecked,
}) => {
  const { t } = useTranslation();
  const { handleSubmit } = useForm();
  const [consentContent, setConsentContent] = useState();
  async function onSubmit(data) {
    setCurrentStep(5);
  }
  useEffect(() => {
    const econsentPDFContent = async () => {
      await getConsentPDFContent(
        config.COMPANY_NAME === "everlake"
          ? "EL_Electronic_Consent_June2023.html"
          : "Electronic_Consent_June2023.html",
        "inline"
      )
        .then((consentPDFContent) => {
          setConsentContent(consentPDFContent);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    econsentPDFContent();
  }, []);

  return (
    <>
      <form
        className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-medium"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div id="divpdfcontent">
          <iframe
            className="xl:h-[500px] w-full overflow-hidden"
            title="test"
            srcDoc={consentContent}
          />
          <label className="ui-checkbox">
            <input
              id="selectIAgree"
              key="selectIAgree"
              type="checkbox"
              defaultChecked={isConsentChecked}
              onChange={(e) => {
                setIsConsentChecked(e.target.checked);
              }}
            />
            <div className="ui-checkmark mx-2">
              <svg
                className="ui-icon w-2 h-2 text-white"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-checkmark"></use>
              </svg>
            </div>
            {t("EConsentDialog-agrement")}
          </label>
        </div>
        <div className="mt-4 text-right">
          <button
            className="ui-btn-secondary ui-btn-min-w mt-2"
            type="button"
            onClick={() => setCurrentStep(3)}
          >
            <Trans
              i18nKey="CustomerRegister-step-2-form-button-1"
              components={{
                srText: <span className="sr-only"></span>,
              }}
            ></Trans>
          </button>
          <button
            className="ui-btn-primary ui-btn-min-w mt-2"
            type="submit"
            disabled={!isConsentChecked}
          >
            <Trans
              i18nKey="CustomerRegister-step-2-form-button-2"
              components={{
                srText: <span className="sr-only"></span>,
              }}
            ></Trans>
          </button>
        </div>
      </form>
    </>
  );
};

export default PanelFour;
